import { lazy } from "react";
import Loadable from "app/components/Loadable";

const BorrowerType = Loadable(lazy(() => import("./BorrowerType")));

const BorrowerTypeRoute = [{ path: "/BorrowerType", element: <BorrowerType /> }];
export default BorrowerTypeRoute;
